
import React, { useState } from "react";
import { FiEdit } from "react-icons/fi";
import { FaRegEye } from "react-icons/fa";
import ProspectresalePlotUnitForm from "./ProspectresalePlotUnitForm";



const ProspectResalePlotUnitPage = ({
  tableRows = [],
  onAdd,
  onEdit,
  formatINR,
  formatINRShort,
  getStatusStyles,
  propertyId,
}) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);

  const handleAddClick = () => {
    setSelectedUnit({
      id: null, // Explicitly null for new units
      order: tableRows.length + 1,
      unitNo: "",
      sqft: null,
      ratePerSqft: null,
      northDimension: "",
      eastDimension: "",
      westDimension: "",
      southDimension: "",
      roadFacing: "",
      roadWidth: "",
      createdBy: "",
      unitStatus: { id: "", name: "Available" },
      propertyId,
      registrationCharge: null,
      preferredLocationCharge: null,
      notes: "",
      vendorGuideline: null,
      governmentGuideline: null,
      isLocallyCreated: true, // Mark as locally created
    });
    setIsFormOpen(true);
  };

  const handleEditClick = (unit) => {
    console.log("Editing unit:", unit);
    // Ensure we maintain the identification method (id or localId)
    const unitToEdit = {
      ...unit,
      // Preserve the original identification
      originalId: unit.id,
      originalLocalId: unit.localId,
    };
    setSelectedUnit(unitToEdit);
    setIsFormOpen(true);
  };

  const handleSave = (unitData) => {
    console.log("Saving unit data:", unitData);
    console.log("Selected unit:", selectedUnit);
    
    // Check if this is editing an existing unit (either with real ID or local ID)
    const isEditingExisting = selectedUnit && (selectedUnit.id || selectedUnit.localId);
    
    if (isEditingExisting) {
      // This is editing an existing unit - call onEdit
      const editData = {
        ...unitData,
        originalId: selectedUnit?.originalId || selectedUnit?.id,
        originalLocalId: selectedUnit?.originalLocalId || selectedUnit?.localId,
      };
      console.log("Calling onEdit with:", editData);
      onEdit(editData);
    } else {
      // This is a completely new unit - call onAdd
      console.log("Calling onAdd with:", unitData);
      onAdd(unitData);
    }
    setIsFormOpen(false);
    setSelectedUnit(null);
  };

  const handleCancel = () => {
    setIsFormOpen(false);
    setSelectedUnit(null);
  };

  return (
    <div className="bg-white rounded-[10px] shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full table-auto">
          <thead>
            <tr className="bg-gray-100 text-base text-center rounded-md">
              <th className="px-4 py-3 text-gray-700 font-medium">Unit No.</th>
              <th className="px-4 py-3 text-gray-700 font-medium">SQ. FT</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Rate Per SQ.FT</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Total Price</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Road Facing</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Action</th>
            </tr>
          </thead>
          <tbody>
            {tableRows.length > 0 ? (
              tableRows.map((row, index) => (
                <tr
                  key={row.id || row.localId || `unit-${index}`}
                  className={`border-b text-center border-gray-200 hover:bg-gray-50 ${
                    row.isLocallyCreated ? '' : ''
                  }`}
                  title={row.isLocallyCreated ? 'This unit is created locally and not yet saved to server' : ''}
                >
                  <td className="px-4 py-4 text-sm flex items-center justify-center gap-2">
                    {row.unitNo || "N/A"}
                    {/* {row.isLocallyCreated && (
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800">
                        Local
                      </span>
                    )} */}
                  </td>
                  <td className="px-4 py-4 text-sm">{row.sqft || "N/A"}</td>
                  <td className="px-4 py-4 text-sm">{row.ratePerSqft ? formatINR(row.ratePerSqft) : "N/A"}</td>
                  <td
                    className="px-4 py-4 text-sm cursor-pointer"
                    title={row.sqft && row.ratePerSqft ? formatINR(row.sqft * row.ratePerSqft) : "N/A"}
                  >
                    {row.sqft && row.ratePerSqft ? formatINRShort(row.sqft * row.ratePerSqft) : "N/A"}
                  </td>
                  <td className="px-4 py-4 text-sm">
                    {row.roadFacing || row.roadFacingSide?.name || "N/A"}
                  </td>
                  <td className="px-4 py-4">
                    {row.isPlaceholder ? (
                      <button
                        onClick={handleAddClick}
                        className="px-3 py-1 bg-customGreen text-white rounded-md text-sm hover:bg-green-600"
                      >
                        Add
                      </button>
                    ) : (
                      <button
                        onClick={() => handleEditClick(row)}
                        className={`p-2 rounded-md hover:bg-gray-100 ${row.unitStatus?.name === "Available" || row.unitStatus?.name === "N/A" ? "text-customGreen" : "text-gray-600"}`}
                      >
                        {row.unitStatus?.name === "Available" || row.unitStatus?.name === "N/A" ? (
                          <FiEdit size={20} />
                        ) : (
                          <FaRegEye size={20} />
                        )}
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="py-8 text-gray-500 text-center">
                  No units found. Click "Add New Unit" to start.
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={6} className="px-4 py-4 text-center">
                <button
                  onClick={handleAddClick}
                  className="px-4 py-2 bg-customGreen text-white rounded-md hover:bg-green-600"
                >
                  Add New Unit
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      {isFormOpen && (
        <ProspectresalePlotUnitForm
          unit={selectedUnit}
          onSave={handleSave}
          onCancel={handleCancel}
          propertyId={propertyId}
          existingUnits={tableRows}
        />
      )}
    </div>
  );
};

export default ProspectResalePlotUnitPage;